/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PremiumDetail } from './premiumDetail';
import { PremiumDiff } from './premiumDiff';
import { PremiumDiscountAmn } from './premiumDiscountAmn';
import { PremiumPaymentModality } from './premiumPaymentModality';
import { SimulationCommercialProduct } from './simulationCommercialProduct';

export interface HomeSimulation {
  /**
   * Numerical reference that MAPFRE assigns to each simulation to identify it
   */
  simulationId?: string;
  /**
   * Numerical reference that MAPFRE assigns to each object to quote
   */
  quoteId?: string;
  /**
   * Company Identifier
   */
  companyId?: string;
  /**
   * Date when the simulation actually occurs
   */
  effectiveDate?: Date;
  /**
   * Date of capture data (time stamp)
   */
  captureDate?: Date;
  simulationCommercialProduct?: SimulationCommercialProduct;
  premiumDetail?: PremiumDetail;
  premiumDiff?: PremiumDiff;
  premiumDiscountAmn?: PremiumDiscountAmn;
  /**
   * list of available payment modalities with their prices
   */
  premiumPaymentModalities?: Array<PremiumPaymentModality>;
}
